import React, { useState } from 'react';
import { TreeSelect } from 'antd';
import { TreeSelectProps } from 'antd/lib/tree-select';
import { Resource } from '../ResourceSelection';

interface ResourceSelectionTreeProps extends TreeSelectProps<string> {
  resources: Resource[];
  defaultValue: string;
  onChange: (resource: string) => void;
}

interface Tree {
  title: React.ReactNode;
  value: string;
  key: string;
  children: Tree[] | undefined;
}

const transformResourcesToTreeData = (resources: Resource[]) =>
  resources.reduce((accum, resource) => {
    accum.push({
      title: resource.resource,
      value: resource.resource,
      key: resource.resource,
      children: resource.children ? transformResourcesToTreeData(resource.children) : undefined,
    });
    return accum;
  }, [] as Tree[]);

const ResourceSelectionTree: React.FC<ResourceSelectionTreeProps> = ({
  defaultValue,
  resources,
  onChange,
  ...selectProps
}) => {
  const [value, setValue] = useState<string>(defaultValue);
  const [treeData, setTreeData] = useState<Tree[]>();
  React.useEffect(() => {
    setTreeData(transformResourcesToTreeData(resources));
  }, []);

  const onChangeCL = React.useCallback(
    (val) => {
      setValue(val);
      if (onChange) {
        onChange(val);
      }
    },
    [value],
  );
  return (
    (treeData && treeData.length > 0 && (
      <TreeSelect
        showSearch
        defaultOpen
        value={value}
        style={{ width: '100%' }}
        placeholder="Select resource"
        treeDefaultExpandAll
        {...selectProps}
        onChange={onChangeCL}
        treeData={treeData}
      />
    )) ||
    null
  );
};

export default ResourceSelectionTree;
